export default "__VITE_ASSET__DgP5FjyN__"